/**
 * After <shopify-account> login, the page is still guest HTML.
 * Poll a tiny section for a real server session, then reload once.
 */
(function initCustomerLoginReload() {
  const LOGGED_IN_CLASS = "customer-logged-in";
  const SESSION_SECTION = "boa-customer-session";
  const SESSION_MARKER = "data-boa-customer-logged-in";
  const RETRY_WAITS_MS = [200, 700, 1500];

  let isPolling = false;

  function pageShowsLoggedInCustomer() {
    return document.body.classList.contains(LOGGED_IN_CLASS);
  }

  function shopRoot() {
    return window.Shopify?.routes?.root || "/";
  }

  function pause(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  async function sessionHasCustomer() {
    const response = await fetch(`${shopRoot()}?section_id=${SESSION_SECTION}`, {
      credentials: "same-origin",
      cache: "no-store",
    });

    if (!response.ok) {
      return false;
    }

    const sectionMarkup = await response.text();
    return sectionMarkup.includes(SESSION_MARKER);
  }

  async function reloadAfterSuccessfulLogin() {
    if (isPolling || pageShowsLoggedInCustomer()) {
      return;
    }

    isPolling = true;

    try {
      for (const waitBeforeCheckMs of RETRY_WAITS_MS) {
        await pause(waitBeforeCheckMs);

        if (pageShowsLoggedInCustomer()) {
          return;
        }

        const loggedInOnServer = await sessionHasCustomer();
        if (loggedInOnServer) {
          window.location.reload();
          return;
        }
      }
    } catch {
      // Network failures are fine — opening the account sheet again retries.
    } finally {
      isPolling = false;
    }
  }

  function bindLoginReload() {
    document.querySelectorAll("shopify-account").forEach((accountElement) => {
      accountElement.addEventListener("close", reloadAfterSuccessfulLogin);
    });

    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        reloadAfterSuccessfulLogin();
      }
    });
  }

  if (pageShowsLoggedInCustomer()) {
    return;
  }

  if (customElements.get("shopify-account")) {
    bindLoginReload();
    return;
  }

  customElements.whenDefined("shopify-account").then(bindLoginReload);
})();
